import EventCard from "./EventCard";
import type { Event, Venue } from "../types/api";

export default function EventCarousel({
  events,
  venues = [],
}: {
  events: Event[];
  venues?: Venue[];
}) {
  const vById = Object.fromEntries(venues.map((v) => [v.id, v]));
  if (events.length === 0) return null;
  return (
    <div className="h-scroll">
      {events.map((e) => (
        <EventCard
          key={e.id}
          event={e}
          venueName={vById[e.venueId]?.name}
          venueCity={vById[e.venueId]?.city}
        />
      ))}
    </div>
  );
}
